import React from 'react';
import { Toggle } from '../../components/behavior/Toggle';
import { NavigationLink, NavigationList } from '../../components/Navigation';
import {
  NavigationListItemMobile,
  NavigationToggleButton
} from '../../components/NavigationMobile';
import { getSvgIconKey, SvgIcon } from '../../components/SvgIcon';
import { selectVehicleCenters } from '../../provider/Typo3Provider/selectors';
import { MenuEntry } from '../../provider/Typo3Provider/types';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import { Maybe } from '../../types';
import { countryCodeMapping } from '../../utils/countryCodeMappings';

interface LocationsProps {
  locationEntries: MenuEntry[];
  countryEntries: MenuEntry[];
}

const Locations = ({
  typo3,
  locationEntries,
  countryEntries
}: LocationsProps & WithTypo3Props) => {
  const [mainEntry] = locationEntries;
  const vehicleCenters = selectVehicleCenters(typo3);
  const toggleContent = countryEntries.map(countryEntry => {
    const { uid, title, icon } = countryEntry;
    const iconKey = getSvgIconKey(icon);
    const countryCode: Maybe<string> = iconKey
      ? countryCodeMapping[iconKey as keyof typeof countryCodeMapping]
      : null;
    const locations = vehicleCenters.filter(
      vehicleCenter => vehicleCenter.countryCode === countryCode
    );
    if (locations.length === 0) {
      return null;
    } else {
      const link =
        locations.length === 1 ? locations[0].link : countryEntry.link;
      return (
        <NavigationListItemMobile key={uid}>
          <NavigationLink to={link}>
            {iconKey && <SvgIcon icon={iconKey} />}
            {title}
          </NavigationLink>
        </NavigationListItemMobile>
      );
    }
  });
  return (
    <Toggle
      render={({ active, onClick }) => (
        <NavigationListItemMobile
          // preventDefault
          onClick={onClick}
          open={active}
        >
          <NavigationLink to={mainEntry.link}>
            <span>{mainEntry.title}</span>
          </NavigationLink>
          <NavigationToggleButton />
          <NavigationList>{toggleContent}</NavigationList>
        </NavigationListItemMobile>
      )}
    />
  );
};

export default withTypo3(Locations);
